export const FETCH_PAYMENTS_REQUESTED = 'FETCH_PAYMENTS_REQUESTED';
export const FETCH_PAYMENTS_SUCCEEDED = 'FETCH_PAYMENTS_SUCCEEDED';
export const SORT_PAYMENTS_REQUESTED = 'SORT_PAYMENTS_REQUESTED';
export const SORT_PAYMENTS_SUCCEEDED = 'SORT_PAYMENTS_SUCCEEDED';
export const UPDATE_PAYMENT_FILTER = 'UPDATE_PAYMENT_FILTER';
export const SELECT_ALL_VISIBLE_PAYMENT = 'SELECT_ALL_VISIBLE_PAYMENT';
export const SELECT_ALL_PAYMENT = 'SELECT_ALL_PAYMENT';
export const REINDEX_SELECTED_ITEM = 'REINDEX_SELECTED_ITEM';
export  const REMOVE_CHANGED_ITEM = 'REMOVE_CHANGED_ITEM';
